
import React from 'react';
import Layout from '@/components/layout/Layout';
import { useGetAgents } from '@/hooks/use-agent';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Loader2, Plus, AlertCircle, BarChart3 } from 'lucide-react';
import AgentList from '@/components/agents/AgentList';
import AgentPerformanceReport from '@/components/reports/AgentPerformanceReport';

const Agents = () => {
  const { data: agents, isLoading, error } = useGetAgents();

  return (
    <Layout>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Agents</h1>
        <Button asChild>
          <Link to="/agents/new">
            <Plus className="mr-2 h-4 w-4" />
            Add Agent
          </Link>
        </Button>
      </div>

      <Tabs defaultValue="list" className="space-y-4">
        <TabsList>
          <TabsTrigger value="list">Agent List</TabsTrigger>
          <TabsTrigger value="performance">
            <BarChart3 className="h-4 w-4 mr-2" />
            Performance Report
          </TabsTrigger>
        </TabsList>

        <TabsContent value="list">
          {isLoading ? (
            <Card>
              <CardContent className="flex justify-center items-center py-8">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
              </CardContent>
            </Card>
          ) : error ? (
            <Card>
              <CardContent className="flex flex-col items-center py-8 gap-2">
                <AlertCircle className="h-8 w-8 text-destructive" />
                <p>Failed to load agents</p>
              </CardContent>
            </Card>
          ) : (
            <AgentList agents={agents || []} />
          )}
        </TabsContent>

        <TabsContent value="performance">
          <AgentPerformanceReport />
        </TabsContent>
      </Tabs>
    </Layout>
  );
};

export default Agents;
